import { render, staticRenderFns } from "./scene-4.vue?vue&type=template&id=50385924"
import script from "./scene-4.vue?vue&type=script&lang=js"
export * from "./scene-4.vue?vue&type=script&lang=js"
import style0 from "./scene-4.vue?vue&type=style&index=0&id=50385924&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports